import React from 'react';
import { Box, Stack, Container, Flex, Heading } from '@chakra-ui/react';
import Link from '@components/atoms/Link';
import Media from '@components/atoms/Media';
import HeaderFont from '@components/atoms/HeaderFont';
import RichText from '@components/atoms/RichText';
import { Wrapper } from '@components';
import { dataLayerClick } from '@helpers/dataLayerPush';

const Infographic = ({
  data: {
    title,
    subTitle,
    bodyCopy,
    buttonText,
    buttonLink,
    infographicImage,
    backgroundColour,
    textColour,
    watermarkImage
  }
}) => {
  return (
    <Box
      bgColor={
        backgroundColour.startsWith(`#`)
          ? backgroundColour
          : `#${backgroundColour}`
      }
      color={textColour.startsWith(`#`) ? textColour : `#${textColour}`}
      pos="relative">
      <Wrapper>
        <Stack
          direction={[`column`, null, `row`]}
          pos="relative"
          zIndex={1}
          maxH={[`unset`, null, `600px`]}>
          <Container
            py={{ base: 14, md: 16 }}
            px={{ base: 0, md: 10 }}
            centerContent
            maxW="unset">
            <Heading
              size="2xl"
              color="inherit"
              textAlign="left"
              maxW="17ch"
              mb="1rem"
              lineHeight="3rem"
              textTransform="uppercase">
              {title}
            </Heading>
            <Media
              media={infographicImage}
              imgStyle={{
                objectFit: `contain`
              }}
            />
          </Container>
          <Flex
            py={{ base: 14, md: 16 }}
            pt={{ base: 0 }}
            px={{ base: 0, md: 10 }}
            w="100%"
            minW={[`fit-content`, null, `unset`]}
            maxW="unset"
            flexDirection="column"
            justifyContent="center"
            align="flex-start">
            <Box color="inherit" fontWeight="600" mb="4" fontSize="xl">
              {subTitle}
            </Box>
            <RichText
              data={bodyCopy.data.bodyCopy}
              color="inherit"
              extraSX={{ strong: { fontWeight: `600`, fontSize: `lg` } }}
            />
            <Link
              href={buttonLink}
              variant="whiteButton"
              textAlign="center"
              mt="2"
              onClick={() => {
                dataLayerClick({
                  event: `cta_click`,
                  clickText: buttonText,
                  clickUrl: buttonLink
                });
              }}>
              <HeaderFont fontWeight="700">{buttonText}</HeaderFont>
            </Link>
          </Flex>
        </Stack>
        <Box
          pos="absolute"
          bottom="0"
          right="0"
          maxW="fit-content"
          minW="300px"
          w="50%"
          zIndex={0}>
          <Media media={watermarkImage} />
        </Box>
      </Wrapper>
    </Box>
  );
};

export default Infographic;
